export const GLOBAL_DOMAIN = process.env.REACT_APP_GLOBAL_DOMAIN 
? process.env.REACT_APP_GLOBAL_DOMAIN 
: 'https://devapi.atumlife.com/api';
// 'http://3.108.30.187:3001/';
// 'http://app.atumlife.com:3001/';
// 'http://app.atumlife.com:3010/';
// 'https://demoapi.atumlife.com/'


export const BIKE_DOMAIN = 
// 'http://192.168.100.5:3002/';
// 'http://192.168.41.77:3001'
// 'http://app.atumlife.com:3001/';
// 'http://app.atumlife.com:3010/';
'https://referrals.atumlife.com/';

export const IMAGE_DOMAIN = (process.env.REACT_APP_IMG_DOMAIN + '/' + process.env.REACT_APP_CONTAINER_NAME + '/')
? (process.env.REACT_APP_IMG_DOMAIN + '/' + process.env.REACT_APP_CONTAINER_NAME + '/')
: 'https://vilassetmanagement.blob.core.windows.net/atumlifeapptest/';

export const PRODUCTS = GLOBAL_DOMAIN + '/v1/products';
export const LOGIN = GLOBAL_DOMAIN + '/v1/adminusers/login';
export const ADD_USER = GLOBAL_DOMAIN + '/v1/adminusers';
export const USERS_LIST = GLOBAL_DOMAIN + '/v1/adminusers?type=list';
export const PRODUCTS_LIST = GLOBAL_DOMAIN + '/v1/products?type=list';
export const UPLOAD_MEDIA = GLOBAL_DOMAIN + '/v1/products/';
export const ADD_STORE = GLOBAL_DOMAIN + '/v1/stores';
export const STORES_LIST = GLOBAL_DOMAIN + '/v1/stores?type=list';
export const ADD_LOOKUP_TYPES = GLOBAL_DOMAIN + '/v1/lookuptypes';
export const LOOKUP_TYPES_LIST = GLOBAL_DOMAIN + '/v1/lookuptypes?type=list';
export const LOOKUP_TYPES_DROPDOWN = GLOBAL_DOMAIN + '/v1/lookuptypes?type=list&limit=500';
export const ADD_LOOKUP_CODES = GLOBAL_DOMAIN + '/v1/lookupcodes';
export const LOOKUP_CODES_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=list';
export const UPDATE_DELIVERY_ADDRESS = GLOBAL_DOMAIN + '/v1/lookupcodes';
export const DELIVERY_ADDRESS = GLOBAL_DOMAIN + '/v1/lookupcodes?type=list&limit=1000&addressLookups=true';
export const ADD_STORE_COUNTRIES_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=COUNTRIES';
export const ADD_STORE_STATES_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&';
export const GENDER_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=GENDER';
export const ADD_STORE_MANAGERS_LIST = GLOBAL_DOMAIN + '/v1/adminusers?type=drop';
export const USER_ROLES_DROPDOWN = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=USER_ROLES';
export const ADD_USER_ROLES = GLOBAL_DOMAIN + '/v1/userroles';
export const ROLES_LIST = GLOBAL_DOMAIN + '/v1/userroles?type=list&limit=500';
export const ROLE_DROPDOWN = GLOBAL_DOMAIN + '/v1/userroles?type=drop&limit=500';
export const EDIT_USER_ROLES = GLOBAL_DOMAIN + '/v1/userroles/'
export const VIEW_PRODUCT = GLOBAL_DOMAIN + '/v1/products/'; 
export const ADD_STORE_CATEGORIES_LIST = GLOBAL_DOMAIN + '/v1/categories?type=drop&limit=100';
export const EDIT_PRODUCT = GLOBAL_DOMAIN + '/v1/products/';
export const BANNERS_LIST = GLOBAL_DOMAIN + '/v1/banners?type=list';
export const ADD_BANNERS = GLOBAL_DOMAIN + '/v1/banners';
export const UPLOAD_IMAGE_BANNER = GLOBAL_DOMAIN + '/v1/banners/';
export const VIEW_BANNER = GLOBAL_DOMAIN + '/v1/banners/';
export const EDIT_BANNER = GLOBAL_DOMAIN + '/v1/banners/';
export const SMS = 'http://sms.amyenterprises.in//v2/sms/send';
export const BULK_UPLOAD_PRODUCTS = GLOBAL_DOMAIN + '/v1/products?action=productsBulkUpload';
export const FAQS = GLOBAL_DOMAIN + '/v1/faqs';
export const QUESTIONS_LIST = GLOBAL_DOMAIN + '/v1/faqs?type=list';
export const EDIT_FAQS = GLOBAL_DOMAIN + '/v1/faqs/';
export const VIEW_USERS = GLOBAL_DOMAIN + '/v1/adminusers/';
export const EDIT_USERS = GLOBAL_DOMAIN + '/v1/adminusers/';
export const VIEW_STORES = GLOBAL_DOMAIN + '/v1/stores/';
export const EDIT_STORES = GLOBAL_DOMAIN + '/v1/stores/';
export const EDIT_LOOKUP_TYPES = GLOBAL_DOMAIN + '/v1/lookuptypes/';
export const VIEW_LOOKUP_TYPES = GLOBAL_DOMAIN + '/v1/lookuptypes/';
export const EDIT_LOOKUP_CODES = GLOBAL_DOMAIN + '/v1/lookupcodes/';
export const VIEW_LOOKUP_CODES = GLOBAL_DOMAIN + '/v1/lookupcodes/';
export const CATEGORIES_LIST = GLOBAL_DOMAIN + '/v1/categories?type=list&';
export const ADD_CATEGORIES = GLOBAL_DOMAIN + '/v1/categories';
export const UPLOAD_IMAGE_CATEGORIES = GLOBAL_DOMAIN + '/v1/categories/';
export const EDIT_CTEGORIES = GLOBAL_DOMAIN + '/v1/categories/';
export const CHANGE_PASSWORD = GLOBAL_DOMAIN + '/v1/adminusers/';
export const STORE_MANAGERS_LIST = GLOBAL_DOMAIN + '/v1/adminusers?type=list&storemanager=true';
export const NOTIFICATIONS_LIST  = GLOBAL_DOMAIN + '/v1/notifications?type=list';
export const EDIT_NOTIFICATIONS = GLOBAL_DOMAIN + '/v1/notifications/';
export const ADD_NOTIFICATIONS = GLOBAL_DOMAIN + '/v1/notifications';
export const UPLOAD_IMAGE_NOTIFICATIONS = GLOBAL_DOMAIN + '/v1/notifications/';
export const ADD_NOTIFICATION_TYPES = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=NOTIFICATION_TYPES';
export const ADD_NOTIFICATION_DELIVERY_TYPES = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=NOTIFICATION_DELIVERY_TYPES';
export const VIEW_NOTIFICATIONS = GLOBAL_DOMAIN + '/v1/notifications/';
export const END_USERS_LIST = GLOBAL_DOMAIN + '/v1/endusers?type=list';
export const END_USERS_DROPDOWN_LIST = GLOBAL_DOMAIN + '/v1/endusers?type=dropdown&limit=1000';
export const USER_CART_LIST = GLOBAL_DOMAIN + '/v1/usercart?type=list&limit=500&user_id=';
export const USER_ORDER_LIST = GLOBAL_DOMAIN + '/v1/userorders?type=list&limit=500&user_id=';
export const ORDER_LIST = GLOBAL_DOMAIN + '/v1/userorders?type=list';
export const ORDER_ITEMS = GLOBAL_DOMAIN + '/v1/orderitems?type=list&limit=500&orderTrackerId=';
export const ORDERS = GLOBAL_DOMAIN + '/v1/userorders/';
export const SUBMITORDER = GLOBAL_DOMAIN + '/v1/userorders';
export const CART = GLOBAL_DOMAIN + '/v1/usercart/';
export const PRODUCTBULKDELETE = GLOBAL_DOMAIN + '/v1/products/?action=bulkdelete';
export const CATEGORYBULKDELETE = GLOBAL_DOMAIN + 'apii/v1/categories/?action=bulkdelete';
export const PAYMENT_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings?type=list&settingName=PAYMENT_SETTINGS';
export const WALLET_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings?type=list&settingName=WALLET_SETTINGS';
export const COUPON_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings?type=list&settingName=COUPON_SETTINGS';
export const ATUM_SETTINGS = BIKE_DOMAIN + '/v1/atumsettings?type=list&settingName=ATUM_REFERRAL_SETTINGS';
export const CART_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings?type=list&settingName=CART_SETTINGS';
export const EDIT_PAYMENT_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings';
export const EDIT_WALLET_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings';
export const EDIT_COUPON_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings';
export const EDIT_ATUM_SETTINGS = BIKE_DOMAIN + '/v1/atumsettings';
export const EDIT_CART_SETTINGS = GLOBAL_DOMAIN + '/v1/configsettings';
export const EXPORT_DATA = GLOBAL_DOMAIN + '/v1/masterdata?type=export&pageName=';
export const ADMIN_LIST = GLOBAL_DOMAIN + '/v1/adminusers?type=drop';
export const CUSTOMER_LIST = GLOBAL_DOMAIN + '/v1/endusers?type=list&limit=1000';
export const COUPON_LIST = GLOBAL_DOMAIN + '/v1/coupons';
export const ADD_COUPON = GLOBAL_DOMAIN + '/v1/coupons';
export const EDIT_COUPON = GLOBAL_DOMAIN + '/v1/coupons/';
export const STORE_LIST = GLOBAL_DOMAIN + '/v1/stores?type=drop&search=';
export const COUPON_PRIVACY_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=COUPON_PRIVACY_TYPES&LOOKUP_NAME=PUBLIC';
export const COUPON_TYPE_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=COUPON_TYPES';
export const COUPONS_PLATFORM = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=COUPONS_PLATFORM';
export const COUPON_VALUE_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=COUPON_VALUE_TYPE';
export const USER_COUPON_LIST = GLOBAL_DOMAIN + '/v1/coupons?type=list&userId=';
export const USER_COUPON_HISTORY = GLOBAL_DOMAIN + "/v1/coupontransactions?type=list&couponId=";
export const BIKE_OWN_LIST = BIKE_DOMAIN+'/v1/userreferralcodes?type=list';
export const ADD_BIKE_OWN = BIKE_DOMAIN + '/v1/userreferralcodes';
export const ADD_BIKE_REFER = BIKE_DOMAIN + '/v1/userreferralhistory';
export const BIKE_REFER_LIST = BIKE_DOMAIN + '/v1/userreferralhistory?type=list&limit=1000&referredBy=';
export const BIKE_TRANSACTION = BIKE_DOMAIN + '/v1/transactionshistory';
export const BIKE_TRANSACTION_LIST = BIKE_DOMAIN + '/v1/transactionshistory?type=list&limit=50&userId=';
export const REPORTS_LIST = GLOBAL_DOMAIN + '/v1/commondbapi?action=getOrdersByProduct';
export const CATEGORIES_LIST_DROPDOWN = GLOBAL_DOMAIN + '/v1/categories?type=drop&limit=1000';
export const Products_LIST = GLOBAL_DOMAIN + '/v1/products?type=drop&limit=1000';
export const DASHBOARD_LIST = GLOBAL_DOMAIN + '/v1/dashboards?type=list&limit=10&dashboard=true';
export const BLOG_LIST = GLOBAL_DOMAIN + '/v1/blogs?type=list';
export const ADD_BLOG = GLOBAL_DOMAIN + '/v1/blogs';
export const EDIT_BLOG = GLOBAL_DOMAIN + '/v1/blogs/';
export const UPLOAD_IMAGE_BLOG = GLOBAL_DOMAIN + '/v1/blogs/';
export const VERIFYUSER = GLOBAL_DOMAIN + '/v1/endusers?action=verifyuser';
export const PRODUCT_ATTRIBUTE_LIST = GLOBAL_DOMAIN + '/v1/productattributes?type=list';
export const ADD_PRODUCT_ATTRIBUTE = GLOBAL_DOMAIN + '/v1/productattributes';
export const EDIT_PRODUCT_ATTRIBUTE = GLOBAL_DOMAIN + '/v1/productattributes/';
export const MEASUREMENT_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=MEASUREMENTS';
export const PRODUCT_ATTRIBUTE_TYPES_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=PRODUCT_ATTRIBUTE_TYPES';
export const PRODUCT_ATTRIBUTE_TYPE_NAME_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=';
export const USER_TRANSACTIONS_LIST = GLOBAL_DOMAIN + '/v1/usertransactions?type=list&limit=1000&userId=';
export const PRODUCT_FAMILY_LIST = GLOBAL_DOMAIN + '/v1/productfamily?type=drop&limit=500';
export const COLOR_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=COLORS';
export const MEASUREMENT_VALUE_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=';
export const PRODUCT_FAMILY_DETAILS = GLOBAL_DOMAIN + '/v1/products?action=getProductFamilyDefaultProduct';
export const CHARGE_TYPE_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=CHARGE_TYPE';
export const BANNER_TYPE_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=BANNER_TYPE';
export const OFFER_BANNER_TYPE_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=OFFER_BANNER_TYPE';
export const BANNER_CATEGORY = GLOBAL_DOMAIN + '/v1/categories?type=drop&limit=100';
export const BANNER_PRODUCTS = GLOBAL_DOMAIN + '/v1/products?type=list&limit=1000';
export const BANNER_PLATFORM_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=PLATFORM_TYPE_BANNERS';
export const ADD_PRODUCT_FAMILY = GLOBAL_DOMAIN + '/v1/productfamily';
export const DOWNLOAD_PRODUCT_TEMPLATE = GLOBAL_DOMAIN + '/v1/commondbapi?action=downloadProductsBulkuploadTemplate';
export const UPDATE_PRODUCT_IMAGE = GLOBAL_DOMAIN + '/v1/products/';
export const DELETE_PRODUCT_IMAGE = GLOBAL_DOMAIN + '/v1/products?action=deleteImage';
export const ORDER_DELIVERY = GLOBAL_DOMAIN + '/v1/deliverymodule/submitOrderToDeliveryClient';
export const ORDER_DELIVERY_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=ORDER_DELIVERY';
export const DELIVERY_ZONES_LIST = GLOBAL_DOMAIN + '/v1/lookupcodes?type=drop&LOOKUP_TYPE_NAME=DELIVERY_ZONES';
export const SHIPPING_DELIVERY_CHARGES = GLOBAL_DOMAIN + '/v1/shippinganddeliverycharges';
export const GET_LOGS = GLOBAL_DOMAIN + '/v1/commondbapi?action=getloggers';
export const CHANGE_ORDER_STATUS = GLOBAL_DOMAIN + '/v1/userorders?action=updateorderstatus';